import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import adminUserReducer from './adminUserSlice'
import adminCardReducer from './adminCardSlice'
import adminAffiliationReducer from './adminAffiliationSlice'
import notificationProcessingReducer from './notificationProcessingSlice'
import userManagementReducer from './userManagementSlice'
import notificationHistoryReducer from './notificationHistorySlice'
import registedInformationReducer from './registedInformationSlice'
import historyManagementReducer from './historyManagementSlice'
import cardManagementReducer from './cardManagementSlice'
import affiliationManagementReducer from './affiliationManagementSlice'
import adminDownloadReducer from './downloadSlice'
import adminCardGroupReducer from './adminCardGroupSlice'
import bulkNotificationReducer from './bulkNotificationSlice'
import cardsetManagementReducer from './cardsetManagementSlice'
import adminDocumentSubmitReducer from './adminDocumentSubmitSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    adminCard: adminCardReducer,
    cardManagement: cardManagementReducer,
    adminUser: adminUserReducer,
    adminAffiliation: adminAffiliationReducer,
    notificationProcessing: notificationProcessingReducer,
    userManagement: userManagementReducer,
    notificationHistory: notificationHistoryReducer,
    registedInformation: registedInformationReducer,
    historyManagement: historyManagementReducer,
    affiliationManagement: affiliationManagementReducer,
    downloadManagement: adminDownloadReducer,
    adminCardGroup: adminCardGroupReducer,
    bulkNotification: bulkNotificationReducer,

    // 🔽 追加（ここだけ）
    cardsetManagement: cardsetManagementReducer,
    adminDocumentSubmit: adminDocumentSubmitReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          '/cloud-app/registration-information-list/download-all-images/fulfilled',
        ],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch